import { render, staticRenderFns } from "./OpmerkingenTab.vue?vue&type=template&id=10f07ce5"
import script from "./OpmerkingenTab.vue?vue&type=script&lang=js"
export * from "./OpmerkingenTab.vue?vue&type=script&lang=js"
import style0 from "./OpmerkingenTab.vue?vue&type=style&index=0&id=10f07ce5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports